// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true,"publicPath":"../../"}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"id":"data-v-670627af","scoped":false,"hasInlineConfig":false}!./~/px2rem-loader?{"remUnit":37.5}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 206
// module chunks = 27